import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { PieChart, PieChartLegends } from 'components/PieChart/index'
import FormattedLargeNumber from 'components/FormattedLargeNumber'
import NoData from 'components/NoData'
import messages from './messages'
import styles from './DashboardCharts.scss'

const ENTITY_TYPES = ['domestic', 'foreign']

const chartColors = ['hsl(149, 70%, 50%)', 'hsl(29, 70%, 50%)']

function DashboardCharts({
  entities = {
    businesses: {},
    individuals: {},
  },
}) {
  const { businesses = {}, individuals = {} } = entities

  const businessesChartItems = ENTITY_TYPES.map((key, index) => ({
    id: key,
    label: key,
    value: businesses[key] || 0,
    color: chartColors[index],
  }))

  const individualsChartItems = ENTITY_TYPES.map((key, index) => ({
    id: key,
    label: key,
    value: individuals[key] || 0,
    color: chartColors[index],
  }))

  const hasLegends = Object.keys(businesses).length > 0

  const totalBusinessEntities = businesses.domestic || 0 + businesses.foreign || 0
  const totalIndividiualEntities = individuals.domestic || 0 + individuals.foreign || 0

  return (
    <div className={styles.container}>
      <section className={styles.section}>
        <h4 className={styles.secondaryTitle}>
          <FormattedMessage {...messages.titles.businesses} />
        </h4>
        <div className={styles.chartWrapper}>
          <PieChart data={businessesChartItems} className={styles.chart} innerClassName={styles.total}>
            {totalBusinessEntities ? <FormattedLargeNumber value={totalBusinessEntities} /> : <NoData />}
          </PieChart>
          {hasLegends && (
            <PieChartLegends
              isTitled
              type='currency'
              direction='column'
              shape='circle'
              legends={businessesChartItems}
              className={styles.legends}
            />
          )}
        </div>
      </section>
      <section className={styles.section}>
        <h4 className={styles.secondaryTitle}>
          <FormattedMessage {...messages.titles.individuals} />
        </h4>
        <div className={styles.chartWrapper}>
          <PieChart data={individualsChartItems} className={styles.chart} innerClassName={styles.total}>
            {totalIndividiualEntities ? <FormattedLargeNumber value={totalIndividiualEntities} /> : <NoData />}
          </PieChart>
          {hasLegends && (
            <PieChartLegends
              isTitled
              type='currency'
              direction='column'
              shape='circle'
              legends={individualsChartItems}
              className={styles.legends}
            />
          )}
        </div>
      </section>
    </div>
  )
}

DashboardCharts.propTypes = {
  entities: PropTypes.shape({
    total: PropTypes.number,
    businesses: PropTypes.shape({
      domestic: PropTypes.number,
      foreign: PropTypes.number,
    }),
    individuals: PropTypes.shape({
      domestic: PropTypes.number,
      foreign: PropTypes.number,
    }),
  }),
}

export default DashboardCharts
